export default __webpack_public_path__ + "a16aebd05c666720798798fc4e44e6be.svg";